<template>
    <DCard
        padding
    >
        <Form
            :errors="formErrors ? formErrors : errors"
            :account-groups="accountGroups"
            :account-statuses="accountStatuses"
            :check-successful="checkSuccessful"
            :check-message="checkMessage"
            :account-group-data-templates="accountGroupDataTemplates"
            :account-tags="accountTags"
            :account-options="accountOptions"
            @form-submitted="submitData"
            @test-account="testAccount"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Products/FulfillmentAccounts/Form'
import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

export default {
    name: 'FulfillmentAccountCreate',
    components: {
        Form,
        DConnectionErrorModal
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        accountGroups: {
            type: Array,
            default () {
                return []
            }
        },
        accountTags: {
            type: Array,
            default () {
                return []
            }
        },
        accountGroupDataTemplates: {
            type: Array,
            default () {
                return []
            }
        },
        accountStatuses: {
            type: Array,
            default () {
                return []
            }
        },
        accountOptions: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            checkSuccessful: null,
            checkMessage: null,
            formErrors: null,
            connectionException: null
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('products.accounts.store'))
        },
        testAccount (form) {
            const self = this
            self.connectionException = null
            window.axios.post(this.$route('products.accounts.check'), form)
                .then(function (response) {
                    self.formErrors = null
                    self.checkSuccessful = response.data.success
                    self.checkMessage = response.data.message
                })
                .catch(function (error) {
                    if (error.response.data.errors !== undefined) {
                        self.formErrors = error.response.data.errors

                        for (const key in self.formErrors) {
                            if (typeof self.formErrors[key] === 'object') {
                                self.formErrors[key] = self.formErrors[key][0]
                            }
                        }
                    }

                    if (error?.response.data.exception !== undefined) {
                        self.connectionException = error?.response.data.exception
                    }

                    self.checkSuccessful = false
                })
        },
        closeErrorCheckModal () {
            this.connectionException = null
        }
    }
}
</script>
